// import SomeIcon from '@/assets/icons/bw/devices/devices-01.svg'

import dev1 from '@/assets/icons/bw/devices/devices-01.svg'
import dev2 from '@/assets/icons/bw/devices/devices-02.svg'
import dev3 from '@/assets/icons/bw/devices/devices-03.svg'
import dev4 from '@/assets/icons/bw/devices/devices-04.svg'
import dev5 from '@/assets/icons/bw/devices/devices-05.svg'
import dev6 from '@/assets/icons/bw/devices/devices-06.svg'
import dev7 from '@/assets/icons/bw/devices/devices-07.svg'
import dev8 from '@/assets/icons/bw/devices/devices-08.svg'
import dev9 from '@/assets/icons/bw/devices/devices-09.svg'
import dev10 from '@/assets/icons/bw/devices/devices-10.svg'
import dev11 from '@/assets/icons/bw/devices/devices-11.svg'
import dev12 from '@/assets/icons/bw/devices/devices-12.svg'
import dev13 from '@/assets/icons/bw/devices/devices-13.svg'
import dev14 from '@/assets/icons/bw/devices/devices-14.svg'
import dev15 from '@/assets/icons/bw/devices/devices-15.svg'
import dev16 from '@/assets/icons/bw/devices/devices-16.svg'
import dev17 from '@/assets/icons/bw/devices/devices-17.svg'
import dev18 from '@/assets/icons/bw/devices/devices-18.svg'
import dev19 from '@/assets/icons/bw/devices/devices-19.svg'
import dev20 from '@/assets/icons/bw/devices/devices-20.svg'
import dev21 from '@/assets/icons/bw/devices/devices-21.svg'
import hand1 from '@/assets/icons/bw/hands/hands-01.svg'
import hand2 from '@/assets/icons/bw/hands/hands-02.svg'
import hand3 from '@/assets/icons/bw/hands/hands-03.svg'
import hand4 from '@/assets/icons/bw/hands/hands-04.svg'
import hand5 from '@/assets/icons/bw/hands/hands-05.svg'
import hand6 from '@/assets/icons/bw/hands/hands-06.svg'
import hand7 from '@/assets/icons/bw/hands/hands-07.svg'
import hand8 from '@/assets/icons/bw/hands/hands-08.svg'
import hand9 from '@/assets/icons/bw/hands/hands-09.svg'
import hand10 from '@/assets/icons/bw/hands/hands-10.svg'
import hand11 from '@/assets/icons/bw/hands/hands-11.svg'
import hand12 from '@/assets/icons/bw/hands/hands-12.svg'
import hand13 from '@/assets/icons/bw/hands/hands-13.svg'
import people1 from '@/assets/icons/bw/people/people-01.svg'
import people2 from '@/assets/icons/bw/people/people-02.svg'
import people3 from '@/assets/icons/bw/people/people-03.svg'
import people4 from '@/assets/icons/bw/people/people-04.svg'
import people5 from '@/assets/icons/bw/people/people-05.svg'
import people6 from '@/assets/icons/bw/people/people-06.svg'
import people7 from '@/assets/icons/bw/people/people-07.svg'
import people8 from '@/assets/icons/bw/people/people-08.svg'
import people9 from '@/assets/icons/bw/people/people-09.svg'
import people10 from '@/assets/icons/bw/people/people-10.svg'
import people11 from '@/assets/icons/bw/people/people-11.svg'
import people12 from '@/assets/icons/bw/people/people-12.svg'
import people13 from '@/assets/icons/bw/people/people-13.svg'
import people14 from '@/assets/icons/bw/people/people-14.svg'
import people15 from '@/assets/icons/bw/people/people-15.svg'
import people16 from '@/assets/icons/bw/people/people-16.svg'
import people17 from '@/assets/icons/bw/people/people-17.svg'
import people18 from '@/assets/icons/bw/people/people-18.svg'
import people19 from '@/assets/icons/bw/people/people-19.svg'
import people20 from '@/assets/icons/bw/people/people-20.svg'
import vir1 from '@/assets/icons/bw/viruses/viruses-01.svg'
import vir2 from '@/assets/icons/bw/viruses/viruses-02.svg'
import vir3 from '@/assets/icons/bw/viruses/viruses-03.svg'
import vir4 from '@/assets/icons/bw/viruses/viruses-04.svg'
import vir5 from '@/assets/icons/bw/viruses/viruses-05.svg'
import col6 from '@/assets/icons/color/covid.svg'
import col7 from '@/assets/icons/color/covid-ahnds.svg'
import col8 from '@/assets/icons/color/covid-cloth.svg'
import col9 from '@/assets/icons/color/covid-coffin.svg'
import col10 from '@/assets/icons/color/covid-cold.svg'
import col11 from '@/assets/icons/color/covid-doc.svg'
import col12 from '@/assets/icons/color/covid-flag.svg'
import col13 from '@/assets/icons/color/covid-lungs.svg'
import col14 from '@/assets/icons/color/covid-mask.svg'
import col15 from '@/assets/icons/color/covid-micro.svg'
import col16 from '@/assets/icons/color/covid-nos.svg'
import col17 from '@/assets/icons/color/covid-palne.svg'
import col18 from '@/assets/icons/color/covid-tissue.svg'
import col19 from '@/assets/icons/color/covid-headache.svg'
import col20 from '@/assets/icons/color/covid-anti-group.svg'
import col21 from '@/assets/icons/color/covid-dna.svg'
import col22 from '@/assets/icons/color/covid-man.svg'
//---
import close from '@/assets/icons/ui/times-solid.svg'

export default {
  name: 'PrtIcon',
  props: {
    icon: {
      type: String,
      default: 'dev1'
    }
  },
  components: {
    dev1,
    dev2,
    dev3,
    dev4,
    dev5,
    dev6,
    dev7,
    dev8,
    dev9,
    dev10,
    dev11,
    dev12,
    dev13,
    dev14,
    dev15,
    dev16,
    dev17,
    dev18,
    dev19,
    dev20,
    dev21,
    hand1,
    hand2,
    hand3,
    hand4,
    hand5,
    hand6,
    hand7,
    hand8,
    hand9,
    hand10,
    hand11,
    hand12,
    hand13,
    people1,
    people2,
    people3,
    people4,
    people5,
    people6,
    people7,
    people8,
    people9,
    people10,
    people11,
    people12,
    people13,
    people14,
    people15,
    people16,
    people17,
    people18,
    people19,
    people20,
    vir1,
    vir2,
    vir3,
    vir4,
    vir5,
    col6,
    col7,
    col8,
    col9,
    col10,
    col11,
    col12,
    col13,
    col14,
    col15,
    col16,
    col17,
    col18,
    col19,
    col20,
    col21,
    col22,
    close

    // dev1
  },
  created() {
    // this.svg = require(`${this.icons[this.icon]}`)
    // this.svg = SomeIcon
    // const path = this.icons[this.icon]
    // console.log(path)
    // this.svg = dev1
    // console.log(this.svg)
  },

  // computed: {
  // 	currentTabComponent: function() {
  // 		return this.currentTab.toLowerCase()
  // 	}
  // },
  data: () => {
    return {
      // currentTab: 'dev3',

      svg: '',

      icons: {}
    }
  }
}
